// plugins/vendor-prefixer.ts
import * as cssVendor from "css-vendor";
import "./index";
var VendorPrefixerPlugin = class {
  matchModifier(path) {
    return true;
  }
  generateFlattenedStyle(pathStyle, flattenedStyle) {
    Object.keys(pathStyle.style ?? {}).forEach((cssprop) => {
      const supportedValue2 = cssVendor.supportedValue(cssprop, pathStyle.style[cssprop]);
      pathStyle.style[cssVendor.supportedProperty(cssprop)] = supportedValue2 === false ? pathStyle.style[cssprop] : supportedValue2;
    });
    return false;
  }
  generateStyleSheetRule(_, styles, sheet) {
    return false;
  }
};
export {
  VendorPrefixerPlugin
};
